import React from 'react'
import './Footer.css'

function Footer() {
  const shopInfo = {
    name: 'meta wer shop',
    description: 'магазин одежды',
    phone: '+7 (999) 123-45-67',
    schedule: 'Ежедневно с 9:00 до 21:00',
    links: [
      { name: 'Доставка', icon: '🚛', url: '#' },
      { name: 'Оплата', icon: '💳', url: '#' },
      { name: 'Контакты', icon: '📞', url: '#' },
      { name: 'Отзывы', icon: '📝', url: '#' }
    ],
    socials: [
      { name: 'Telegram', icon: '📱', url: 'https://t.me/meta_wer_shop_channel', class: 'telegram' },
      { name: 'Instagram', icon: '📷', url: 'https://instagram.com/meta_wer_shop', class: 'instagram' },
      { name: 'VK', icon: '🔵', url: 'https://vk.com/meta_wer_shop', class: 'vk' },
      { name: 'WhatsApp', icon: '💬', url: 'https://wa.me/79991234567', class: 'whatsapp' }
    ]
  }

  return (
    <footer className="app-footer">
      {/* Полезные ссылки */}
      <div className="footer-section">
        <h3 className="footer-title">Полезные ссылки</h3>
        <div className="footer-links">
          {shopInfo.links.map((link, index) => (
            <a key={index} href={link.url} className="footer-link">
              <span className="footer-icon">{link.icon}</span>
              <span>{link.name}</span>
            </a>
          ))}
        </div>
      </div>

      {/* Социальные сети */}
      <div className="footer-section">
        <h3 className="footer-title">Наши соцсети</h3>
        <div className="footer-socials">
          {shopInfo.socials.map((social, index) => (
            <a 
              key={index} 
              href={social.url} 
              className={`social-link ${social.class}`}
              target="_blank" 
              rel="noopener noreferrer"
            >
              {social.icon}
            </a>
          ))}
        </div>
      </div>

      {/* Контактный телефон */}
      <div className="footer-section">
        <h3 className="footer-title">Контактный телефон</h3>
        <a href={`tel:${shopInfo.phone}`} className="footer-phone">
          {shopInfo.phone}
        </a>
        <p className="footer-schedule">{shopInfo.schedule}</p>
      </div>

      {/* Низ футера */}
      <div className="footer-bottom">
        <p className="footer-copyright">
          © 2025 {shopInfo.name}. Все права защищены.
        </p>
        <p className="footer-info">
          {shopInfo.description}
        </p>
      </div>
    </footer>
  )
}

export default Footer
